<template>
  <MainNavbar
    class="bg-transparent fixed-top border-bottom"
    mwClass=""
    className="m-auto"
  />
  <div class="bg-gerund-color">  
    <OurTeam />
    <ASymphonyOfBrilliance />
  </div>
  <IncreaseYourBrands />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import OurTeam from "../components/OurTeam/OurTeam.vue";
import ASymphonyOfBrilliance from "../components/OurTeam/ASymphonyOfBrilliance.vue";
import IncreaseYourBrands from "../components/Common/IncreaseYourBrands.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "OurTeamPage",
  components: {
    MainNavbar,
    OurTeam,
    ASymphonyOfBrilliance,
    IncreaseYourBrands,
    MainFooter,
  },
});
</script>